import { useState, useEffect } from "react";
import successStudent1 from "../assets/images/SuccessStudent1.jpg";
import successStudent2 from "../assets/images/SuccessStudent2.jpg";

const stories = [
  {
    image: successStudent1,
  },
  {
    image: successStudent2,
  },
  {
    image: successStudent2,
  },
  {
    image: successStudent1,
  },
];

const SuccessStoriesSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 2) % stories.length); 
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const visibleStories = [
    stories[index],
    stories[(index + 1) % stories.length],
  ];

  return (
    <section className="relative py-12 px-6 bg-gradient-to-r from-[#060511] to-[#040311] overflow-hidden">

      <h2 className="text-center text-white text-4xl font-bold">
        Success Stories
        <span className="block h-[3px] w-20 bg-red-500 mx-auto mt-2 rounded-full"></span>
      </h2>

      <p className="text-center text-gray-300 mt-4 italic text-xl">
        "Don't just take our word for it" <br />
        Hear with our intern's, what they say
      </p>

      <div className="mt-14 flex justify-center gap-10">

        {visibleStories.map((story, i) => (
          <div
            key={i}
            className="relative w-[440px] h-[270px] rounded-2xl overflow-hidden shadow-xl transition-all duration-700"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-pink-600 to-purple-700"></div>
            <div className="relative m-[2px] h-[calc(100%-4px)] bg-[#2761ad] rounded-2xl flex p-2 text-white">

              <div className="w-full flex flex-col justify-between">
              <img
                  src={story.image}
                  alt="image"
                  className="h-[250px] object-contain"
                />

              </div>


            </div>
          </div>
        ))}

      </div>
    </section>
  );
};

export default SuccessStoriesSection;
